
/*
 * ECONOCEL - AURIS
 * Acciones del carrito lateral
 * Notas, calculador de envíos y mensajes de regalo.
 */

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.cartNoteData = this.querySelector("#cartNote");
        this.button = this.querySelector(
          "button.button__save"
        );

        if (!this.cartNoteData || !this.button) return;

        this.carInit();

        this.button.addEventListener(
          "click",
          this.onSave.bind(this)
        );
      }

      async carInit() {
        try {
          const response = await fetch("/cart.js");
          if (!response.ok) return;

          const cart = await response.json();

          if (cart.note !== null) {
            this.cartNoteData.value = cart.note;
          }
        } catch (error) {
          console.error("Error al cargar nota:", error);
        }
      }

      async onSave(event) {
        event.preventDefault();

        this.button.classList.add("loading");

        try {
          const response = await fetch(
            routes.cart_update_url,
            {
              ...fetchConfig(),
              body: JSON.stringify({
                note: this.cartNoteData.value
              })
            }
          );

          if (!response.ok) {
            throw new Error(
              "No se pudo guardar la nota."
            );
          }

          this.closest("details")?.removeAttribute(
            "open"
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.button.classList.remove("loading");
        }
      }
    }
  );
}

/*
 * CALCULADOR DE ENVÍOS
 * Consulta las tarifas configuradas en Shopify.
 */

if (!customElements.get("shipping-calculator")) {
  customElements.define(
    "shipping-calculator",
    class ShippingCalculator extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(
          "button.button__save"
        );

        this.shippingCountry = this.querySelector(
          "#all--countries-shipping"
        );

        this.countryState = this.querySelector(
          "#AddressProvince_shipping"
        );

        this.shippingCountryZip = this.querySelector(
          "#ShippingAddressZip"
        );

        this.shippingRatePackage = this.querySelector(
          ".shipping_rate_package"
        );

        this.shippingAddressWrapper = this.querySelector(
          ".shipping_rate_message"
        );

        this.shippingAddressCount = this.querySelector(
          ".shipping_address_count"
        );

        if (
          !this.button ||
          !this.shippingCountry ||
          !this.shippingCountryZip ||
          !this.shippingRatePackage
        ) {
          return;
        }

        this.initCountries();

        this.button.addEventListener(
          "click",
          this.onSave.bind(this)
        );
      }

      initCountries() {
        const country = this.shippingCountry;

        const peru = Array.from(
          country.options
        ).find(option => {
          const value = option.value.toLowerCase();

          return value === "peru" || value === "pe";
        });

        if (!peru) {
          this.showError(
            "No se encontró Perú en los países disponibles."
          );
          this.button.disabled = true;
          return;
        }

        country.value = peru.value;

        // Cargar regiones usando los datos de Shopify.
        if (
          window.Shopify?.CountryProvinceSelector &&
          this.countryState
        ) {
          try {
            new Shopify.CountryProvinceSelector(
              "all--countries-shipping",
              "AddressProvince_shipping",
              {
                hideElement:
                  "AddressProvinceContainerNewShiping"
              }
            );

            country.value = peru.value;

            country.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );

          } catch (error) {
            console.warn(
              "Error al inicializar regiones:",
              error
            );
          }
        }

        // Dejar solamente Perú visible.
        Array.from(country.options).forEach(option => {
          if (option !== peru) {
            option.remove();
          }
        });

        country.value = peru.value;
      }

      showError(message) {
        this.shippingAddressWrapper?.classList.add(
          "no-js-inline"
        );

        const paragraph = document.createElement("p");

        paragraph.className = "error mt-15";
        paragraph.textContent = message;

        this.shippingRatePackage.replaceChildren(
          paragraph
        );
      }

      async onSave(event) {
        event.preventDefault();

        if (this.button.disabled) return;

        const postal =
          this.shippingCountryZip.value.trim();

        if (!/^\d{5}$/.test(postal)) {
          this.showError(
            "Ingresa un código postal peruano válido de 5 dígitos."
          );

          this.shippingCountryZip.focus();
          return;
        }

        this.button.disabled = true;
        this.button.classList.add("loading");

        this.shippingRatePackage.replaceChildren();

        this.shippingAddressWrapper?.classList.add(
          "no-js-inline"
        );

        try {
          const params = new URLSearchParams({
            "shipping_address[zip]": postal,
            "shipping_address[country]": "Peru",
            "shipping_address[province]":
              this.countryState?.value || ""
          });

          const root = (
            window.Shopify?.routes?.root || "/"
          ).replace(/\/?$/, "/");

          const url =
            root +
            "cart/shipping_rates.json?" +
            params.toString();

          const response = await fetch(url, {
            credentials: "same-origin",
            headers: {
              Accept: "application/json"
            }
          });

          if (!response.ok) {
            let errorDetails = "";

            try {
              errorDetails = JSON.stringify(
                await response.json()
              );
            } catch (_) {}

            console.warn(
              "Error de Shopify:",
              response.status,
              errorDetails
            );

            throw new Error(
              "No fue posible consultar las tarifas de envío. " +
              "Verifica tu destino e inténtalo nuevamente."
            );
          }

          const data = await response.json();

          const rates = Array.isArray(
            data.shipping_rates
          ) ? data.shipping_rates : [];

          if (!rates.length) {
            this.showError(
              "No hay tarifas disponibles para este destino. " +
              "Contáctanos para coordinar tu envío."
            );
            return;
          }

          if (this.shippingAddressCount) {
            this.shippingAddressCount.textContent =
              String(rates.length);
          }

          this.shippingAddressWrapper?.classList.remove(
            "no-js-inline"
          );

          const currency =
            window.shopCurrencySymbol || "S/ ";

          rates.forEach(rate => {
            const paragraph = document.createElement("p");

            paragraph.className = "mb-0";

            const amount = Number(rate.price);

            const price = Number.isFinite(amount)
              ? amount.toFixed(2)
              : rate.price;

            paragraph.textContent =
              `${rate.name}: ${currency}${price}`;

            this.shippingRatePackage.appendChild(
              paragraph
            );
          });

        } catch (error) {
          console.error(
            "Error calculando tarifas:",
            error
          );

          this.showError(
            error.message ||
            "No se pudo calcular el envío."
          );

        } finally {
          this.button.disabled = false;
          this.button.classList.remove("loading");
        }
      }
    }
  );
}

/*
 * MENSAJES DE REGALO
 */

if (!customElements.get("gift-wrap-message")) {
  customElements.define(
    "gift-wrap-message",
    class GiftMessage extends HTMLElement {
      constructor() {
        super();

        this.giftMessage = this.querySelector(
          "#giftMessage"
        );

        this.button = this.querySelector(
          "button.button__save"
        );

        if (!this.giftMessage || !this.button) return;

        this.giftMessageInit();

        this.button.addEventListener(
          "click",
          this.onSave.bind(this)
        );
      }

      async giftMessageInit() {
        try {
          const response = await fetch("/cart.js");
          if (!response.ok) return;

          const cart = await response.json();

          if (
            Object.prototype.hasOwnProperty.call(
              cart.attributes,
              "gift_note"
            )
          ) {
            this.giftMessage.value =
              cart.attributes.gift_note || "";
          }
        } catch (error) {
          console.error(
            "Error al cargar mensaje de regalo:",
            error
          );
        }
      }

      async onSave(event) {
        event.preventDefault();

        this.button.classList.add("loading");

        try {
          const response = await fetch(
            routes.cart_update_url,
            {
              ...fetchConfig(),
              body: JSON.stringify({
                attributes: {
                  gift_note: this.giftMessage.value
                }
              })
            }
          );

          if (!response.ok) {
            throw new Error(
              "No se pudo guardar el mensaje."
            );
          }

          this.closest("details")?.removeAttribute(
            "open"
          );

        } catch (error) {
          console.error(error);
        } finally {
          this.button.classList.remove("loading");
        }
      }
    }
  );
}
